
import Vue from 'vue'
import { EntityService } from '@/services/entity.service'
import { validationMixin } from 'vuelidate'
import { required, maxLength, email } from 'vuelidate/lib/validators'

const entityService = new EntityService()

export default Vue.extend({
  name: 'UserEdit',
  mixins: [validationMixin],
  validations: {
    form: {
      firstName: {
        required,
        maxLength: maxLength(150)
      },
      lastName: { required },
      email: {
        required,
        email
      },
      type: { required }
    }
  },
  props: ['value', 'editEntity'],
  data: () => ({
    entity: 'users',
    isLoading: false,
    projects: [],
    form: {
      id: 0,
      firstName: '',
      lastName: '',
      email: '',
      password: '',
      type: 'user',
      projects: []
    },
    usersType: [
      {
        label: 'Usuario',
        value: 'user'
      },
      {
        label: 'Administrador',
        value: 'admin'
      }
    ]
  }),
  async created () {
    this.projects = await entityService.getList('projects')
    this.form = {
      id: this.editEntity.id,
      firstName: this.editEntity.firstName,
      lastName: this.editEntity.lastName,
      email: this.editEntity.email,
      password: this.editEntity.password,
      type: this.editEntity.type,
      projects: this.editEntity.projects.map(value => value.id)
    }
  },
  methods: {
    toggleModal (value: boolean) {
      this.$emit('input', value)
    },
    async save () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.isLoading = true
        console.log(this.form)
        await entityService.updateEntity(this.editEntity.id, this.entity, this.form)
        this.isLoading = false
        this.$emit('input', false)
      }
    },
    getError: function (element: string) {
      const obj = this.$v.form[element] || { $error: '' }
      if (obj.$error) return 'Campo inválido'
    }
  }
})
